<template>
  <div style="position:relative;">
    <div class="f-container" :style="right_left">
      <div class="form-container">
        <div class="title">您可以通过以下表单和我们联系</div>
        <el-form ref="form" :model="form" label-width="80px" :show-message="false">
          <div class="form-top">
            <div class="form-box">
              <div class="label">姓名<span>*</span></div>
              <el-form-item prop="name"
                            :rules="[{required:true}]">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <div class="label" type="phone">电话<span>*</span></div>
              <el-form-item prop="phone"
                            :rules="[{required:true,pattern:/^1[34578]\d{9}$/,
                            trigger: ['blur', 'change']}]">
                <el-input v-model="form.phone"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <div class="label">微信</div>
              <el-form-item>
                <el-input v-model="form.wechat"></el-input>
              </el-form-item>
            </div>
            <div class="form-box">
              <div class="label">邮箱<span>*</span></div>
              <el-form-item prop="mail"
                            :rules="[{ required:true, trigger: ['blur', 'change'] }]">
                <el-input v-model="form.mail"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-bot">
            <div class="label">留言<span>*</span></div>
            <div style="width: 510px">
              <el-form-item prop="mark"
                            :rules="[{required:true}]">
                <el-input type="textarea" v-model="form.mark" size="small"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-alert
            title="请填写您的姓名、电话及留言"
            type="error"
            show-icon
            v-if="show_warn">
          </el-alert>
          <el-form-item>
            <div class="btn" @click="onSubmit(form)">Submit</div>
          </el-form-item>
        </el-form>
      </div>
      <div class="ill">
        <img src="@/assets/image/contact_home.jpg" alt="">
      </div>
    </div>
    <el-carousel height="160px" class="partner-carousel" :interval="5000">
      <el-carousel-item v-for="(group,key) in partnerGroup" :key="key">
        <div class="partners">
          <div class="partner" v-for="item in group">
            <img :src="$img + item.companyLogo" height="100%">
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
  export default {
    name: "contact",
    data() {
      return {
        form: {
          name: '',
          phone: '',
          wechat: '',
          mail: '',
          mark: ''
        },
        show_warn: false,
        right_left: {
          transition: "all 1s",
          right: "-560px",
          opacity: 0
        },
        partner: [],
        partnerGroup: []
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll, true);
      this.$http.get('/api/partner/info/list').then((res)=>{
        // this.partner
        // console.log(res)
        this.partner = res.data.rows
        let groupSize = 6   //每行显示的logo数
        let groupCount = Math.ceil(this.partner.length/groupSize)  //行数
        console.log(groupCount)
        for (let i = 0;i < groupCount; i++){
          this.partnerGroup[i]=[]
          for (let k = 0;k < groupSize;k++){
            if (this.partner[k+i*groupSize] == undefined)
              continue
            this.partnerGroup[i].push(this.partner[k+i*groupSize])
            // console.log(this.partnerGroup)
          }
        }
      })
      // let groupSize = 6   //每行显示的logo数
      // let groupCount = Math.ceil(partner.length / groupSize)  //行数
      // for (let i = 0; i < groupCount; i++) {
      //   this.partnerGroup[i] = []
      //   for (let k = 0; k < groupSize; k++) {
      //     if (this.partner[k + i * groupSize] == undefined)  //跳过空值
      //       continue
      //     this.partnerGroup[i].push(this.partner[k + i * groupSize])
      //   }
      // }
    },
    methods: {
      //监听滚动条
      handleScroll() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop >= 2200) {
          this.right_left.right = "0px";
          this.right_left.opacity = 1
        }
      },
      //提交表单
      onSubmit(form) {
        //提交表单
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.$http.post('/api/leaveWord/info', this.form).then((res) => {
              console.log(res)
              if (res.data.code === 200) {
                this.$message('提交成功')
                // this.open()
                console.log(res.data.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      }
    }
  }
</script>

<style scoped>
  .f-container {
    position: relative;
    /*display: flex;*/
    height: 790px;
  }

  .form-container {
    width: 600px;
    padding: 150px 0 0 15%;
  }

  .title {
    color: #222;
    font-size: 40px;
    /*font-weight: bold;*/
    margin-bottom: 10px;
  }

  .form-top {
    display: flex;
    width: 600px;
    flex-wrap: wrap;
  }

  .form-box {
    width: 300px;
    display: flex;
    height: 40px;
    margin-top: 20px;
  }

  .label {
    width: 40px;
    font-size: 14px;
    color: #666;
    line-height: 40px;
  }

  .form-box span, .form-bot span {
    color: red;
  }

  .el-form-item {
    margin-left: -70px;
  }

  .form-bot {
    width: 600px;
    margin-top: 20px;
    display: flex;
  }

  .btn {
    width: 210px;
    height: 66px;
    margin-top: 48px;
    margin-left: -10px;
    line-height: 66px;
    text-align: center;
    transition: all .5s;
    color: #fff;
    background-color: #6676e7;
    border-radius: 10px;
    font-size: 26px;
    cursor: pointer;
  }

  .btn:hover {
    transform: scale(1.02);
    background-color: #3a4ccc;
  }

  .ill {
    width: 800px;
    height: 600px;
    /*background-color: #aa3322;*/
    margin-left: 150px;
    position: absolute;
    right: 100px;
    top: 0;
    z-index: -1;
  }

  .partners {
    width: 1500px;
    height: 160px;
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }

  .partner {
    width: 160px;
    height: 100px;
    /*background-color: #333;*/
    margin: 20px 30px;
    color: #fff;
  }

  .partner-carousel {
    width: 1500px;
    z-index: 10;
    position: absolute;
    bottom: -40px;
    left: 50%;
    margin-left: -750px;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/section/contact.vue